import { ChangeDetectionStrategy, Component } from '@angular/core';
import { UiLinkComponent } from '@big-direkt/ui/link';
import { TranslocoPipe } from '@jsverse/transloco';

@Component({
    selector: 'big-ui-footer',
    templateUrl: './footer.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    host: {
        class: 'block',
    },
    imports: [UiLinkComponent, TranslocoPipe],
})
export class FooterComponent {}
